export default "__VITE_ASSET___BCS4uDc__ 100w";